import { inMx, outerOpensaludMainDomain } from '@/helpers/global.helpers'
import { PAYED, FILLING_REPORT, PENDING_PATIENT } from '@/constants/db/consultationStates'
import { VIDEO, INPLACE } from '@/constants/consultationTypes'
import { PENDING_PAYMENT, APPOINTMENT_ERROR } from '@/constants/paymentTypes'
import { GRAY_400_COLOUR, BLUE_COLOUR, RED_COLOUR, WHITE_COLOUR } from '@/constants/colours'
import billingRepository from '@/repositories/BillingRepository'
import videoRepository from '@/repositories/VideoRepository'
import appointmentsRepository from '@/repositories/AppointmentsRepository'

const PREVIEW_ACTION = 'appointments/preview'
const SHOW_CHAT_ACTION = 'chats/showChat'
const APPOINTMENT_REVIEW_ACTION = 'appointments/review'
const DO_REPORT_ACTION = 'appointments/report'
const CANCEL_ACTION = 'appointments/cancel'

export default {
    data () {
        return {
            payment: {
                price: null,
                paymentType: null,
                appointmentId: null,
                ePrescriptionAvailable: null,
                copayment: null
            },
            showPaymentModal: false,
            showConfirmPaymentDialog: false
        }
    },
    methods: {
        getWrittenActionButtons (item) {
            let actions = []
            if (item.loggedPatientId !== item.patientId) return actions
            if (item.doctorName) {
                if (item.errorPayment) actions.push(this.paymentErrorAction(item))
                if (item.appointmentState === PENDING_PATIENT) {
                    actions.push(this.modifyAction(item, true))
                } else if (item.webmailAdditionalInfo && item.webmailViewedByDoctor) {
                    actions.push(item.appointmentState !== PENDING_PATIENT && item.prevStateId === PENDING_PATIENT ? this.modifyAction(item) : this.modifyAction(item, true))
                } else if (item.webmailAdditionalInfo && !item.webmailViewedByDoctor) {
                    actions.push(item.prevStateId === PENDING_PATIENT ? this.showAppointmentAction(item) : this.modifyAction(item))
                } else {
                    actions.push(this.showAppointmentAction(item))
                }
            }
            if (item.appointmentState !== FILLING_REPORT) actions.push(this.cancelAppointmentAction(item))
            return actions
        },
        getWrittenAppointmentsStateTitle (item) {
            if (!item.webmailViewedByDoctor) {
                return item.prevStateId === PENDING_PATIENT ? this.$t('webmailStates.additionalInfoCompleted') : this.$t('webmailStates.pendingConfirm')
            } else if (item.appointmentState !== PENDING_PATIENT && item.prevStateId === PENDING_PATIENT) {
                return this.$t('webmailStates.additionalInfoCompleted')
            } else if (item.appointmentState === PENDING_PATIENT) {
                return this.$t('webmailStates.additionalInfoRequested')
            } else if (item.appointmentState !== FILLING_REPORT) {
                return item.prevStateId === PENDING_PATIENT ? this.$t('webmailStates.additionalInfoCompleted') : this.$t('webmailStates.pendingConfirm')
            } else if (item.appointmentState === FILLING_REPORT) {
                return this.$t('webmailStates.profReviewingCase')
            }
        },
        unpaidAppointment (item) {
            return ((item.consultancyType === INPLACE && item.chargeInplacePlatform) || item.consultancyType === VIDEO) && item.appointmentState <= PAYED && (!item.withCompaniesServices || item.copayment) && (item.price > 0 && !item.noChargeAppointment ? !item.anyPayment : false)
        },
        paymentAction (item) {
            return {title: this.$t('confirm'), icon: 'arrow-right-circle', textColor: WHITE_COLOUR, borderColor: BLUE_COLOUR, backgroundColor: BLUE_COLOUR, action: () => this.payAppointment(PENDING_PAYMENT, item)}
        },
        paymentErrorAction (item) {
            return {title: this.$t('changePaymentMethod'), icon: 'arrow-right-circle', textColor: WHITE_COLOUR, borderColor: BLUE_COLOUR, backgroundColor: BLUE_COLOUR, action: () => this.payAppointment(APPOINTMENT_ERROR, item)}
        },
        modifyAction (item, blink) {
            return {title: this.$t('modify'), icon: 'pencil', textColor: WHITE_COLOUR, borderColor: BLUE_COLOUR, backgroundColor: BLUE_COLOUR, blink: !!blink, action: () => this.$helpers.goToPatientWebApp(`${PREVIEW_ACTION}/${item.appointmentId}`, this.$apiToken)}
        },
        showAppointmentAction (item, eyeIcon) {
            return {title: this.$t('see'), icon: eyeIcon ? 'eye' : 'arrow-right-circle', textColor: GRAY_400_COLOUR, borderColor: GRAY_400_COLOUR, action: () => this.$helpers.goToPatientWebApp(`${PREVIEW_ACTION}/${item.appointmentId}`, this.$apiToken)}
        },
        showChatAction (item) {
            return {title: this.$t('showChat'), icon: 'eye', textColor: GRAY_400_COLOUR, borderColor: GRAY_400_COLOUR, action: () => this.$router.push(`/patient/${SHOW_CHAT_ACTION}/${item.appointmentId}`)}
        },
        reviewAction (item) {
            return {title: this.$t('review'), icon: 'hand-thumbs-up', textColor: WHITE_COLOUR, borderColor: BLUE_COLOUR, backgroundColor: BLUE_COLOUR, action: () => this.$helpers.goToPatientWebApp(`${APPOINTMENT_REVIEW_ACTION}/${item.appointmentId}`, this.$apiToken)}
        },
        invoiceAction (item) {
            return {title: this.$t('invoice'), icon: inMx ? 'currency-dollar' : 'currency-euro', textColor: BLUE_COLOUR, borderColor: BLUE_COLOUR, action: () => {
                let windowReference = window.open()
                    billingRepository.getBillByAppointment(item.appointmentId).then(response => {
                        windowReference.location = response.data
                    })
                }
            }
        },
        prescriptionAction (item) {
            return {title: this.$t('appointmentPrescription'), icon: 'printer', textColor: BLUE_COLOUR, borderColor: BLUE_COLOUR, action: () => {
                appointmentsRepository.getAppointmentPrescription(item.appointmentId).then(response => {
                    let fileURL = URL.createObjectURL(response.data)
                    let fileLink = document.createElement('a')
                    fileLink.href = fileURL
                    fileLink.download = `${this.$t('prescriptions')}_${item.appointmentId}`
                    fileLink.click()
                })
            }
        }
        },
        reportAction (item) {
            return {title: this.$t('appointmentReport'), icon: 'info-circle', textColor: BLUE_COLOUR, borderColor: BLUE_COLOUR, action: () => this.$helpers.goToPatientWebApp(`${DO_REPORT_ACTION}/${item.appointmentId}`, this.$apiToken)}
        },
        cancelAppointmentAction (item) {
            return {title: this.$t('cancel'), icon: 'x-circle', textColor: RED_COLOUR, borderColor: RED_COLOUR, action: () => this.$helpers.goToPatientWebApp(`${CANCEL_ACTION}/${item.appointmentId}`, this.$apiToken)}
        },
        goVideoAction (item, blink) {
            return {title: this.$t('goVideoAppointment'), icon: 'arrow-right-circle', blink: !!blink, textColor: WHITE_COLOUR, borderColor: BLUE_COLOUR, backgroundColor: BLUE_COLOUR, action: () => this.goToVideo(item.appointmentId)}
        },
        goToVideo (appointmentId) {
            videoRepository.getVideoSessionUrl(appointmentId).then(response => {
                if (!response.data.data) {
                    this.$helpers.goToPatientWebApp(`appointments/go/${appointmentId}`, this.$apiToken)
                } else {
                    location.href = `${response.data.data}${outerOpensaludMainDomain() ? `?host=${encodeURIComponent(location.hostname)}` : ''}`
                }
            })
        },
        payAppointment (paymentType, {appointmentId, price, ePrescriptionAvailable, copayment}) {
            this.showPaymentModal = true
            this.payment.paymentType = paymentType
            this.payment.price = price
            this.payment.appointmentId = appointmentId
            this.payment.ePrescriptionAvailable = ePrescriptionAvailable
            this.payment.copayment = copayment
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/appointments.mixin.js